/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { ILandingSection, LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { getContainerClass } from "../section/Container"

/* Protopia Ecosystem component */
export interface ISectionMarkingProps {
    section: ILandingSection
    i: number
}
const SectionMarking = (props: ISectionMarkingProps): JSX.Element => { 
    const settings  = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings ) 
    const sizes     = useLandingSize()
    const p1        = typeof props.section.paddingTop      !== "undefined" ?  props.section.paddingTop     : 75
    const p2        = typeof props.section.paddingBottom   !== "undefined" ?  props.section.paddingBottom  : 75 
    const ref       = useRef(null) 
    
     
    return settings.linesAndHandlers && settings.meatSizes && sizes.width > WINDOW_WIDTH.TABLET
    ?
    <>
        <div className="landing-section-marking-cont pe-surface" ref={ref}>
            <div className={`landing-container-marking ${getContainerClass( props.section.composition?.container )}`} />
            <div 
                className={`landing-padding-marking`} 
                style={{
                    marginTop: p1,
                    marginBottom: p2,
                    height: `calc(100% - ${ p1 + p2 }px)`
                }}
            />
        </div>
    </>
    :
    <></>
}
export default SectionMarking